import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as modal from "../util/modal.ts";
import ApiServer from "../ApiServer.ts";
import * as blackveil from "../lib/blackveil2.ts";

Html.registerWidget('widget/activity-form',{initDom,destroyDom})

ApiServer["custom.wallpublish"] = function(form,success,error){
  if(form.giphy){
    form.tagline.value = (form.tagline.value + "\r\n\r\n" + form.giphy.value).trim();
  }
  ApiServer.wallpublish(form,success,error);
  cancel();
}
amplify.subscribe('newActivity',cancel)
var root: HTMLElement | null = null;

Html.registerDom({
  openPostCancel:cancel,
  openPostMessage:function(){
    import("../form/post-message.mustache").then(function(TPL){
      if(root) root.setAttribute('data-fw-dyn-action',"custom.wallpublish")
      updateHtml(TPL);
    });
  },
  openPostPhoto:function(){
    import("../form/post-photo.mustache").then(function(TPL){
      if(root) root.setAttribute('data-fw-dyn-action',"custom.wallpublishphoto")
      updateHtml(TPL);
    });
  },
  openPostCheckin:function(){
    import("../form/post-checkin.mustache").then(function(TPL){
      if(root) root.setAttribute('data-fw-dyn-action',"custom.checkin")
      updateHtml(TPL);
    })
  },
  openGif:function(){
    const nextEl = this.nextElementSibling as HTMLElement;
    if(nextEl) Html.trigger(nextEl,"opendropdown");
  },
  openPostGif:function(){
    import("../form/post-message.mustache").then(function(TPL){
      if(root) root.setAttribute('data-fw-dyn-action',"custom.wallpublish")
      updateHtml(TPL);
      setTimeout(function(){
        if(root) {
          const gifBtn = root.querySelector("*[data-fw-onclick='openGif']") as HTMLElement;
          if(gifBtn) Html.trigger(gifBtn,"openGif")
        }
      },600);
    });
  }
});
function updateHtml(TPL){
  if(!root) return;
  fixheight();
  const textarea = root.querySelector('textarea') as HTMLTextAreaElement;
  var text = textarea ? textarea.value : '';
  Html.setHtml(root,TPL,{});
  const newTextarea = root.querySelector('textarea') as HTMLTextAreaElement;
  if(newTextarea) {
    newTextarea.focus();
    newTextarea.value = text;
  }
  if(root.dataset.open !== 'true'){
    //root.style.position='relative';
    root.style.zIndex = '11';
    blackveil.show(root).addEventListener('click',askcancel);
    root.dataset.open = 'true';
  }
  adjustheight();
}


function cancel(){
  import("../form/post-default.mustache").then(function(TPL){
    if(!root) return;
    fixheight();
    root.dataset.open = 'false';
    root.dataset.changed = 'false';
    root.setAttribute('data-fw-dyn-action',"custom.wallpublish")
    blackveil.hide(root); // remove() nettoie automatiquement les listeners
    Html.setHtml(root,TPL,{});
    adjustheight();
    setTimeout(function(){
      if(root) root.style.position = 'static';
    },600)
  })
}

async function askcancel(){
  if(!root) return;
  var hasChanged = false;
  //for textarea
  const textarea = root.querySelector('textarea') as HTMLTextAreaElement;
  if(textarea && textarea.value.trim().length>0){
    hasChanged = true;
  }
  //dropped image
  if(root.querySelector('input[name=picture]')){
    hasChanged = true;
  }
  const placeIdInput = root.querySelector('input[name=placeId]') as HTMLInputElement;
  if(placeIdInput && placeIdInput.value){
    hasChanged = true;
  }
  if(hasChanged){
    if(await modal.confirm({title:'discard.title',message:'discard.message',yes:'discard.yes',no:'discard.no'})){
      cancel();
    }
  }else{
    cancel();
  }
}

var timeout: number;
function adjustheight(){
  if(!root) return;
  root.style.overflowY = 'hidden';
  root.style.height = calcHeight()+'px';
  clearTimeout(timeout);
  timeout = window.setTimeout(function(){
    if(!root) return;
    root.style.overflowY = 'visible';
    root.style.height = 'auto';
  },800);
}
function fixheight(){
  if(!root) return;
  root.style.height = calcHeight()+'px';
}
function calcHeight(){
  if(!root) return 0;
  var h = 0;
  Array.from(root.children).forEach((child: HTMLElement) => {
    h += child.offsetHeight;
  });
  const styles = getComputedStyle(root);
  h += parseInt(styles.paddingTop) + parseInt(styles.paddingBottom);
  return h;
}

function initDom(obj: HTMLElement){
  root = obj;
  root.style.transition = 'height 0.6s ease';
  root.style.height = calcHeight()+'px';
  obj.setAttribute('data-fw-form-amplify','newActivity');
  amplify.subscribe('newActivity',cancel);
  amplify.subscribe('resetNewActivity',cancel)

  obj.addEventListener('paste',function(event){
    if(obj.getAttribute('data-fw-dyn-action')==="custom.wallpublish"){
      const clipEvent = event as ClipboardEvent;
      var items = clipEvent.clipboardData?.items;
      var clipboardImages :File[] = [];
      if(items){
        for(var i=0;i<items.length;i++){
          var file = items[i].getAsFile();
          if(file){
            clipboardImages.push(file);
          }
        }
      }
      if(clipboardImages.length){
        (root as any).clipboardImages = clipboardImages;
        Html.trigger(null,'openPostPhoto');
      }
    }
  })

}
function destroyDom(obj: HTMLElement){
  blackveil.hide(root); // remove() nettoie automatiquement les listeners
  amplify.unsubscribe('newActivity',cancel);
  amplify.unsubscribe('resetNewActivity',cancel)
  root = null;
}
